<template>
    <div>
        <b-modal
            id="confirm_redeem_modal"
            modal-class="custom-modal"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="area-modal">
                <div class="content-modal">
                    <div
                        class="header"
                        v-html="lblConfirmRedeem.confirmBodyHeader"
                    ></div>
                    <div class="body" v-html="txtOnBody"></div>
                    <div class="bottom-modal">
                        <div
                            class="btn-close-border btn-cancel"
                            @click="clickCloseConfirmRedeem()"
                        >
                            {{ lblConfirmRedeem.cancel }}
                        </div>
                        <div
                            class="btn-close-border btn-ok"
                            @click="clickConfirmRedeem()"
                        >
                            {{ lblConfirmRedeem.confirm }}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
import Moment from "moment";
import Locale from "@/helper/locale/locale.js";

export default {
    name: "ConfirmRedeemModal",
    props: {
        lbl: Object,
        campaign: Object,
        busModal: Object
    },
    data: function() {
        return {
            headline: "",
            message: "",
            txtOnBody: "",
            lblConfirmRedeem: {},
            lblDate: {}
        };
    },
    mounted: function() {
        this.lblDate = this.lbl.date;
        this.lblConfirmRedeem = this.lbl.confirm_redeem;
        this.txtOnBody = this.lblConfirmRedeem.confirmBodyText.replace(
            "{pointText}",
            this.campaign.pointPerUnit
        );
        this.busModal.$on("showConfirmRedeemModal", this.initialConfirmModal);
        this.busModal.$on("hideConfirmRedeemModal", this.closeConfirmModal);
    },
    methods: {
        //Event
        clickConfirmRedeem: function() {
            this.$emit("clickConfirmRedeem");
            this.closeConfirmModal();
        },
        clickCloseConfirmRedeem: function() {
            this.closeConfirmModal();
        },
        //Function
        initialConfirmModal: function() {
            var minute = this.campaign.minutesValidAfterUsed;
            var isDelivered = false;
            var haveTimer = false;

            if (this.campaign.delivered) isDelivered = true;
            if (
                this.campaign.minutesValidAfterUsed ||
                this.campaign.minutesValidAfterUsed > 0
            )
                haveTimer = true;

            this.headline = this.lblConfirmRedeem.headline;
            switch (this.campaign.type) {
                case Vue.CampaignType.Draw:
                    this.message = isDelivered
                        ? this.lblConfirmRedeem.draw_delivery
                        : this.getDrawMessage(this.lblConfirmRedeem.draw);
                    break;
                case Vue.CampaignType.Free:
                    if (isDelivered) {
                        this.message = this.lblConfirmRedeem.free_delivery;
                    } else {
                        this.message = haveTimer
                            ? this.getTimerMessage(
                                  this.lblConfirmRedeem.free,
                                  minute
                              )
                            : this.lblConfirmRedeem.free_no_timer;
                    }
                    break;
                case Vue.CampaignType.Deal:
                    if (isDelivered) {
                        this.message = this.lblConfirmRedeem.deal_delivery;
                    } else {
                        this.message = haveTimer
                            ? this.getTimerMessage(
                                  this.lblConfirmRedeem.free,
                                  minute
                              )
                            : this.lblConfirmRedeem.deal_no_timer;
                    }
                    break;
                case Vue.CampaignType.Buy:
                    this.message = this.lblConfirmRedeem.buy;
                    break;
                case Vue.CampaignType.Interface:
                    this.message = this.lblConfirmRedeem.interface;
                    break;
                default:
                    break;
            }

            this.$bvModal.show("confirm_redeem_modal");
        },
        closeConfirmModal: function() {
            this.$bvModal.hide("confirm_redeem_modal");
        },
        //Utilities
        getTimerMessage: function(message, minutes) {
            var result = "";
            var days = "";
            var hours = "";
            var minuteAfterUsed = minutes;
            if (minuteAfterUsed >= 60) {
                hours = Math.floor(minuteAfterUsed / 60);
                if (hours >= 24) days = Math.floor(hours / 24);
            }

            if (days) result += days + " " + this.lblDate.days + " ";
            if (hours) result += hours + " " + this.lblDate.hours + " ";
            if (minutes / 60 > 0)
                result += (minutes % 60) + " " + this.lblDate.minutes_short;

            return Util.stringFormat(message, result);
        },
        getDrawMessage: function(message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate)
                .utc()
                .format("YYYY");
            if (Locale.getLocaleCode() === 1054)
                year = result.get("year") + 543;

            var monthString = this.lblDate.month_short[result.format("M") - 1];
            var strDate =
                result.format("DD") +
                " " +
                monthString +
                " " +
                year +
                " | " +
                result.format("HH:mm");

            return Util.stringFormat(message, strDate);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "./modal.scss";
.area-modal {
    .content-modal {
        .header {
            margin-top: 15px;
            color: #000;
            font-size: 1.6rem;
        }
        .body {
            text-align: center;
            color: #000;
            padding: 10px 0px;
            margin-bottom: 15px;
            font-size: 1.5rem;
        }
        .bottom-modal {
            display: inline-flex;
            width: 100%;
            div {
                font-weight: bold;
                display: block;
                margin: 0 auto;
                padding: 2px 20px;
                text-align: center;
                font-size: 1.5rem;
                width: 120px;
                &.btn-cancel {
                    background: #fff;
                }
                &.btn-ok {
                    background: #87030c;
                    color: #fff;
                    border: 1px solid #87030c;
                }
            }
        }
    }
}
</style>
